// Remplacer ces valeurs pour intégrer le logo officiel.
export const BRAND = {
  name: "UGC GO",
  tagline: "De l'idée à ta première vidéo, pas à pas.",
  logoMark: "/brand/logo-mark.png",
  logoFull: "/brand/logo-icon.png",
};

// Modules de la plateforme. Seul le parcours « Ma première vidéo UGC » est actif en V1.
export const MODULES = [{ id: "premiere-video", name: "Ma première vidéo UGC", basePath: "/parcours", active: true }];
